import { watchEffect } from 'vue'

/** The tab title: the unread count ahead of the Inbox name while anything is unread, the page title otherwise. */
export function unreadTitle(count: number, inboxLabel: string, pageTitle: string): string {
  return count > 0 ? `(${count}) ${inboxLabel} · Raldo` : pageTitle
}

/** Keeps `document.title` at the page title, or at the unread Inbox title while the count is above zero. */
export function useUnreadTitle(
  count: () => number,
  inboxLabel: () => string,
  pageTitle: () => string,
): void {
  watchEffect(() => {
    document.title = unreadTitle(count(), inboxLabel(), pageTitle())
  })
}
